import React, { useState, useEffect, useContext } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from 'react-router';

import Leaderboard from "components/overview/Leaderboard";
import Activities from "components/overview/Activities";

import { SocketContext } from "contexts/SocketContext";
import { AppContext } from "contexts/AppContext";

import AuthorizedFunction from "config/AuthorizedFunction";

const Overview = () => {
  // const socket = useContext(SocketContext);
  // const [wsMessage, setWSMessage] = useState("");
  const appContext = useContext(AppContext);
  // const location = useLocation();
  // const searchParams = new URLSearchParams(location.search);

  return (
    // appContext.pageView === VIEW_TYPE.Back ? <Activities /> : <Leaderboard />
    <Leaderboard />
  );
};

export default Overview;
